import storeManager from "store/manager";

const getSymbolDigit = (symbol: string) => {
    const digit = storeManager.symbol.getConfig().data?.find((config: any) => config.symbol === symbol)?.digits || null;
    
    return digit;
}

export default getSymbolDigit;